import clsx from 'clsx'
import React from 'react'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import { SHARE_TEXT } from 'app/ProfileRevampPage/constants'
import { ProfileSocialShareDrawer } from 'app/ProfileRevampPage/components/ProfileSocialShareDrawer'
import { useShare } from 'app/ProfileRevampPage/hooks/useShare'
import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'
import { useBackButton } from 'app/ProfileRevampPage/hooks/useBackButton'

interface IHeaderProps {
  title: string
  subtitle: string
  showPageHeaderContent: boolean
}
const PageHeader = ({
  title,
  subtitle,
  showPageHeaderContent,
}: IHeaderProps) => {
  const { onClickBack } = useBackButton({ fallbackPath: '/home' })

  const {
    shareUrl,
    socialShareDrawerOpen,
    setSocialShareDrawerOpen,
    onClickShare,
  } = useShare()
  const { SETrackClickShareProfile } = useSETrackEvent()

  const onClickShareButton = () => {
    if (!showPageHeaderContent) {
      return
    }

    onClickShare()
    SETrackClickShareProfile({
      pageElement: 'header-button',
    })
  }

  return (
    <>
      <HeaderBar fixed className="shadow-sm">
        <HeaderBarLeftAction
          data-testid="profile-page-header-back-button"
          onClick={() => onClickBack()}
        />
        <HeaderBarTitle
          subtitle={subtitle}
          className={clsx(
            'transition-opacity ease-in-out duration-200',
            showPageHeaderContent && 'opacity-100',
            !showPageHeaderContent && 'opacity-0'
          )}
        >
          <div>{title}</div>
        </HeaderBarTitle>

        <HeaderBarRightAction
          data-testid="profile-page-header-share-button"
          onClick={onClickShareButton}
          className={clsx(
            'transition-opacity ease-in-out duration-200',
            showPageHeaderContent && 'opacity-100 !cursor-pointer',
            !showPageHeaderContent && 'opacity-0 !cursor-default'
          )}
        >
          <Icon
            className={clsx(
              showPageHeaderContent && '!cursor-pointer',
              !showPageHeaderContent && '!cursor-default'
            )}
          >
            share
          </Icon>
        </HeaderBarRightAction>
      </HeaderBar>

      {socialShareDrawerOpen && (
        <ProfileSocialShareDrawer
          isOpen={socialShareDrawerOpen}
          onClose={() => {
            setSocialShareDrawerOpen(false)
          }}
          shareUrl={shareUrl}
          shareText={SHARE_TEXT}
        />
      )}
    </>
  )
}

export default PageHeader
